import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const NeutralFace = t0 => {
  const $ = _c(7);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path id="Vector" d="M13.1248 21.8753H21.8748M32.0832 17.5003C32.0832 25.5544 25.5539 32.0837 17.4998 32.0837C9.44568 32.0837 2.9165 25.5544 2.9165 17.5003C2.9165 9.44617 9.44568 2.91699 17.4998 2.91699C25.5539 2.91699 32.0832 9.44617 32.0832 17.5003Z" strokeWidth="1.5625" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path id="Vector_2" d="M12.3957 13.1253C11.993 13.1253 11.6665 12.7989 11.6665 12.3962C11.6665 11.9935 11.993 11.667 12.3957 11.667C12.7984 11.667 13.1248 11.9935 13.1248 12.3962C13.1248 12.7989 12.7984 13.1253 12.3957 13.1253Z" fill="white" strokeWidth="1.5625" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path id="Vector_3" d="M22.6042 13.1253C22.2015 13.1253 21.875 12.7989 21.875 12.3962C21.875 11.9935 22.2015 11.667 22.6042 11.667C23.0068 11.667 23.3333 11.9935 23.3333 12.3962C23.3333 12.7989 23.0068 13.1253 22.6042 13.1253Z" fill="white" strokeWidth="1.5625" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props) {
    t4 = <IconWrapper {...props} viewBox="0 0 35 35" variant="outline">{t1}{t2}{t3}</IconWrapper>;
    $[5] = props;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export { NeutralFace };